import { gql } from '@apollo/client';

export const CHECK_GRAYSCALE_DRIVER = gql`
    query CheckGrayscaleDriver($configKey: String!) {
        checkGrayscaleDriver(configKey: $configKey)
    }
`;

export interface CheckGrayscaleDriverResponse {
    checkGrayscaleDriver: boolean;
}

export interface CheckGrayscaleDriverVariables {
    configKey: string;
}

